type ITrackingTask = () => void;

const pendingTrackingTasks = new Set<ITrackingTask>();

let areFlushListenersAttached = false;

const callTrackingTask = (task: ITrackingTask) => {
    try {
        task();
    } catch {
        // a failing tracking call must never break the interaction it was attached to
    }
};

/**
 * Runs every task that is still waiting. Used when the page is about to go away - a deferred task
 * whose component (or document) is gone would otherwise never run, which is how the previous
 * attempt at deferring tracking (RP-277) silently dropped events on navigation.
 */
export const flushPendingTrackingTasks = () => {
    if (pendingTrackingTasks.size === 0) {
        return;
    }

    const tasks = Array.from(pendingTrackingTasks);
    pendingTrackingTasks.clear();
    tasks.forEach(callTrackingTask);
};

const attachFlushListeners = () => {
    if (areFlushListenersAttached) {
        return;
    }

    areFlushListenersAttached = true;

    window.addEventListener("pagehide", flushPendingTrackingTasks);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            flushPendingTrackingTasks();
        }
    });
};

/**
 * Defers analytics work until after the browser has painted the response to the interaction, so it
 * stops counting towards INP processing duration.
 *
 * requestAnimationFrame + setTimeout is the same mechanism as `deferDataLayerPushAfterLoad`; unlike
 * `scheduler.postTask` it is guaranteed to land after the next paint. The pending queue is flushed
 * on pagehide/visibilitychange, so events survive a navigation started by the same click.
 */
export const scheduleTrackingTask = (task: ITrackingTask) => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        callTrackingTask(task);
        return;
    }

    attachFlushListeners();
    pendingTrackingTasks.add(task);

    requestAnimationFrame(() => {
        setTimeout(() => {
            if (!pendingTrackingTasks.delete(task)) {
                // already run by a flush
                return;
            }

            callTrackingTask(task);
        }, 0);
    });
};
type ITrackingTask = () => void;

const pendingTrackingTasks = new Set<ITrackingTask>();

let areFlushListenersAttached = false;

const callTrackingTask = (task: ITrackingTask) => {
    try {
        task();
    } catch {
        // a failing tracking call must never break the interaction it was attached to
    }
};

/**
 * Runs every task that is still waiting. Used when the page is about to go away - a deferred task
 * whose component (or document) is gone would otherwise never run, which is how the previous
 * attempt at deferring tracking (RP-277) silently dropped events on navigation.
 */
export const flushPendingTrackingTasks = () => {
    if (pendingTrackingTasks.size === 0) {
        return;
    }

    const tasks = Array.from(pendingTrackingTasks);
    pendingTrackingTasks.clear();
    tasks.forEach(callTrackingTask);
};

const attachFlushListeners = () => {
    if (areFlushListenersAttached) {
        return;
    }

    areFlushListenersAttached = true;

    window.addEventListener("pagehide", flushPendingTrackingTasks);
    document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
            flushPendingTrackingTasks();
        }
    });
};

/**
 * Defers analytics work until after the browser has painted the response to the interaction, so it
 * stops counting towards INP processing duration.
 *
 * requestAnimationFrame + setTimeout is the same mechanism as `deferDataLayerPushAfterLoad`; unlike
 * `scheduler.postTask` it is guaranteed to land after the next paint. The pending queue is flushed
 * on pagehide/visibilitychange, so events survive a navigation started by the same click.
 */
export const scheduleTrackingTask = (task: ITrackingTask) => {
    if (process.env.EXEC_ENV !== "browser" || typeof window === "undefined") {
        callTrackingTask(task);
        return;
    }

    attachFlushListeners();
    pendingTrackingTasks.add(task);

    requestAnimationFrame(() => {
        setTimeout(() => {
            if (!pendingTrackingTasks.delete(task)) {
                // already run by a flush
                return;
            }

            callTrackingTask(task);
        }, 0);
    });
};
